<template>
  <div>
    <data-view-sidebar :isSidebarActive="addNewDataSidebar" :quote_api_id="dataIntervention.quote_api_id" :modeReglement="dataIntervention.modeReglement" :signature="dataIntervention.signature" :intervention_id="dataIntervention.id" :client_email="dataIntervention.client.email" :dataIntervention="dataIntervention" @closeSidebar="toggleDataSidebar" @showLoading="showLoading = true" @closeLoading="showLoading = false"/>

    <vx-card>

      <div class="vx-row">
        <div class="vx-col w-full sm:w-1/2 lg:w-1/2 mb-base">
         
        </div>
        <div class="vx-col w-full sm:w-1/2 lg:w-1/2 mb-base text-right">
       
        </div>
      </div>
      <div class="vx-row">
        <div class="vx-col w-full sm:w-1/2 lg:w-1/2 mb-base">
          <vs-button type="line" line-origin="left" color="success" class="ml-5"  @click="addNewDataSidebar=true" ><feather-icon icon="CheckCircleIcon" svgClasses="h-4 w-4" /> Valider l'intervention</vs-button>

        </div>

      </div>

      <form-wizard ref="wizard" color="rgba(var(--vs-primary), 1)" errorColor="rgba(var(--vs-danger), 1)" :title="null" :subtitle="null" finishButtonText="Submit">

        <!-- tab intervention content -->
       <tab-content title="Intervention" class="mb-5" icon="feather icon-plus-square" :before-change="validateStep1">
        <!-- tab 1 content -->
        <form data-vv-scope="step-1">
          <intervention-tab :dataIntervention="dataIntervention" @showLoading="showLoading = true" @closeLoading="showLoading = false"></intervention-tab>
          <!-- @changeId="changeId($event)" -->
        </form>
      </tab-content>

      <!-- tab devis content -->
      <tab-content title="Devis" class="mb-5" icon="feather icon-file-text">
        <form data-vv-scope="step-2">
          <quote-tab :dataIntervention="dataIntervention" @showLoading="showLoading = true" @closeLoading="showLoading = false"></quote-tab>
        </form>
      </tab-content>
      
      <div slot="footer">

      </div>

    </form-wizard>

    </vx-card>

  </div>
</template>
<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import DataViewSidebar from './Sidebar'

import { FormWizard, TabContent } from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'

import interventionTab from './intervention_tab_by_artisan'
import quoteTab from './quote_tab_by_artisan'


import { mapActions, mapGetters } from 'vuex'
import vSelect from 'vue-select'

// For custom error message
import { Validator } from 'vee-validate';
const dict = {
  custom: {
    date_intervention: {
      required: 'La date d\'intervention est obligatoire'
    },
    lieu_intervention: {
      required: 'Le lieu d\'intervention est obligatoire'
    },
    description_intervention: {
      required: 'La description de problème est obligatoire'
    },
    categorie_intervention : {
      required: 'La catégorie d\'intervention est obligatoire'
    },

    client_email : {
      required: 'L\'email de client est obligatoire'
    },
    client_tel : {
      required: 'Le téléphone de client est obligatoire'
    },
    client_city : {
      required: 'La ville de client est obligatoire'
    },
    client_zipcode : {
      required: 'Le code postal de client est obligatoire'
    },
    client_address : {
      required: 'L\'adresse de client est obligatoire'
    },
    sub_categorie_intervention: {
      required: 'Le type de problème est obligatoire'
    }


  }
};

// register custom messages
Validator.localize('fr', dict);

export default {

  components: {
    VuePerfectScrollbar,interventionTab,DataViewSidebar,vSelect,quoteTab,FormWizard,TabContent,
  },
  props: ['id'],
  data () {
    return {
      dataIntervention: {
        id: null,
        num: null,
        date: new Date(),
        lieu: null,
        status: {label: 'En cours', value: 2},
        description: null,
        emergency : {label: 'Sur rendez-vous', value: 0},
        categorie : null,
        subcategorie : null,
        client_id: null,
        send_rappel: null,
        send_avis: null,
        invoice_api_id: null,
        invoice_status: null,
        quote_api_id:  null,
        signature: null,
        modeReglement: {value: null, label: null},
        client: {
          id: null,
          address: null,
          company: null,
          email: null,
          firstname: null,
          lastname: null,
          siret: null,
          status: null,
          tel: null,
          city: null,
          zipcode: null,
          emergency: null
        }
        
      },
      Status_choices : [
        {label: 'Brouillon', value: 0},
        {label: 'Valider', value: 1},
        {label: 'En cours', value: 2},
        {label: 'Terminer', value: 3},
        {label: 'Refuser', value: 4}
      ],
      Emergency_choices : [
        {label: 'En urgence', value: 1},
        {label: 'Sur rendez-vous', value: 0}
      ],
      showLoading : false,
      activePrompt:false,

      // Data Sidebar
      addNewDataSidebar: false,
    }
  },
  created () {

  },
  computed: {
    ...mapGetters('artisans', {'Artisans_choices' : 'GET_ITEMS'}),

    Interventionid: {
      get: function () {
        return this.id
      },
      set: function () {
      }
    }

  },
  methods: {
    ...mapActions('interventions', {'getIntervention':'getItem', 'sendAvisRequest' : 'sendAvisRequest'}),
    ...mapActions('artisans', {'fetchArtisans': 'fetchItems'}),


    changeId(id) {
      this.Interventionid = id
    },

    toggleDataSidebar(val=false) {
      this.addNewDataSidebar = val
    },

    successMsg(title,msg){
      this.$vs.notify({
        title: title,
        text: msg,
        color:'success',
        iconPack: 'feather',
        icon:'icon-check',
        position:'top-right'
      })
    },

    errorMsg(title,msg){
      this.$vs.notify({
        title: title,
        text: msg,
        color:'danger',
        iconPack: 'feather',
        icon:'icon-check',
        position:'top-right'
      })
    },

    sendAvis(id) {
      this.sendAvisRequest(id).then(result => {
        this.dataIntervention.send_avis = result.data.intervention.send_avis
        this.successMsg("L'ajout","Demande d'avis à été envoyée");
      }).catch(() => {
        this.errorMsg('Demander avis','Trouvé un error lor d\'envoi de demande')
      })
    },

    acceptAlert(){
      this.$vs.notify({
        color:'success',
        title:'Accept Selected',
        text:'Lorem ipsum dolor sit amet, consectetur'
      })
    },

  },
  mounted(){
    this.fetchArtisans()

    if(this.id) {
      this.showLoading = true
      this.getIntervention(this.id).then(result => {
        let intervention = result.data

        this.dataIntervention = {
          id: intervention.id,
          num: intervention.num,
          date: intervention.date_intervention,
          lieu: intervention.lieu,
          status: this.Status_choices[this.Status_choices.findIndex((p) => p.value == intervention.status)],
          description: intervention.description,
          emergency : this.Emergency_choices[this.Emergency_choices.findIndex((p) => p.value == intervention.emergency)],
          categorie : intervention.service_id,
          subcategorie: intervention.sub_service_id,
          client_id: intervention.client_id,
          send_rappel: intervention.send_rappel,
          send_avis: intervention.send_avis,

          invoice_api_id: intervention.invoice ? intervention.invoice.api_id : null,
          invoice_status: intervention.invoice ? intervention.invoice.status : null,
          quote_api_id: intervention.quote ? intervention.quote.api_id : null,
          signature: intervention.quote ? intervention.quote.signature : null,
        
          modeReglement: intervention.quote ? (intervention.quote.payment_type == 'card' ? {value: 'card', label: 'Carte bancaire'} : intervention.quote.payment_type == 'transfer' ? {value: 'transfer', label: 'Virement bancaire'} : intervention.quote.payment_type == 'cash' ? {value: 'cash', label: 'Espèces'} : intervention.quote.payment_type == 'cheque' ? {value: 'cheque', label: 'Chèque'} :  {value: 'paypal', label: 'Paypal'} ): null,
          client: {
            id: intervention.client.id,
            address: intervention.client.address,
            company: intervention.client.company,
            email: intervention.client.email,
            firstname: intervention.client.firstname,
            lastname: intervention.client.lastname,
            siret: intervention.client.siret,
            status: intervention.client.status,
            tel: intervention.client.tel,
            city: intervention.client.city,
            zipcode: intervention.client.zipcode,
            emergency: intervention.client.emergency
          },
          
          price: intervention.price,
          quote: intervention.quote ? intervention.quote : {
            object: null,
            id: null,
            api_id: null,
            num_quote: null,
            date: null,
            date_echeance: null,
            status:"issued",
            payment_type:"card",
            ht: 0,
            ttc: 0,
            tva: 0,
            intervention_id:this.id,
            client_id:intervention.client_id,
            tva_value: intervention.client.company ? 20 : 10,
            lines:[{id: null,item: null,description: null,cost: 0,qty: 1,redc: 0}],
            reduction: false,
            historiques : [],
          },
        
        }


        if(!this.dataIntervention.quote.lines.length){
          this.dataIntervention.quote.lines = [{id: null,item: null,description: null,cost: 0,qty: 1,redc: 0}]
        }

        this.$refs.wizard.activateAll()
        this.showLoading = false

      })
    }
  },
  watch: {
    showLoading (val) {
      if(val == true){
        this.$vs.loading({type: 'radius', color: '#be092f'})
      }else{
        this.$vs.loading.close()
      }
    },
    Interventionid() {
      this.$refs.wizard.activateAll()
    },
    id(val) {
      if(!val) {
        this.dataIntervention = {
          id: null,
          date: new Date(),
          lieu: null,
          status: {label: 'En cours', value: 2},
          description: null,
          emergency : {label: 'Sur rendez-vous', value: 0},
          categorie : null,
          subcategorie : null,
          client_id: null,
          send_rappel: null,
          send_avis: null,
          invoice_api_id: null,
          invoice_status: null,
          quote_api_id: null,
          signature: null,
          modeReglement: {value: null, label: null},
          client: {
            id: null,
            address: null,
            company: null,
            email: null,
            firstname: null,
            lastname: null,
            siret: null,
            status: null,
            tel: null,
            city: null,
            zipcode: null,
            emergency: null
          },
          quote: {
            object: null,
            id: null,
            num_quote: null,
            date: null,
            date_echeance : null,
            status:"issued",
            payment_type:"card",
            intervention_id:this.id,
            client_id:1,
            tva_value: 20,
            lines:[{id: null,item: null,description: null,cost: 0,qty: 1,redc: 0}],
            client:{firstname: null,lastname: null,siret: null,company:null,address:null,zipcode:null,city:null},
            reduction: false,
            historiques: []
          },
          
         
        }
        this.$refs.wizard.reset()
      }
    }
  },
  filters:{
    strPadStart(value, pattern = ""){ // Use padStart to complete the string
      return value.toString().padStart(4,pattern)
    }
  }

}
</script>
<style scoped>
  .vs__selected{
    text-transform: uppercase;
  }
</style>
